export default __webpack_public_path__ + "static/media/gq.1f2b45ca.svg";